import React, { Component } from 'react'
import { MenuItem, FormControl, InputLabel, Select } from '@material-ui/core'
import isEqual from 'lodash/isEqual'
import { ReactComponent as InProgress } from 'assets/img/ic_checked_in_progress.svg'
import { ReactComponent as Checked } from 'assets/img/ic_checked.svg'
import { ReactComponent as Unchecked } from 'assets/img/ic_unchecked.svg'
import {
  STATUS_COMPLETED,
  STATUS_IN_PROGRESS,
  STATUS_NOT_STARTED,
} from 'helpers/jobs'
import { ALL_SELECTED } from 'constants/index'
import { formatMessage } from 'lib/intl'

class NestedList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data,
      allSelected: STATUS_NOT_STARTED,
    }
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props

    if (!isEqual(data, prevProps.data)) {
      this.setState({
        data,
        allSelected: this.getParentStatus(data),
      })
    }
  }

  getAllSelectedState = () => {
    const { data } = this.state

    if (data.length > 0) {
      this.setState({
        allSelected: this.getParentStatus(data),
      })
    }
  }

  handleAllSelectedClick = () => {
    const { allSelected } = this.state
    const changeAllSelected = status => {
      this.setState({
        data: this.makeSelected(status),
        allSelected: status,
      })
    }

    if (
      allSelected === STATUS_NOT_STARTED ||
      allSelected === STATUS_IN_PROGRESS
    ) {
      changeAllSelected(STATUS_COMPLETED)
    }

    if (allSelected === STATUS_COMPLETED) {
      changeAllSelected(STATUS_NOT_STARTED)
    }
  }

  handleExportData = () => {
    const { data } = this.state

    return data.reduce((total, { id, type, selected, childData }) => {
      if (childData && childData.length) {
        if (selected === STATUS_COMPLETED) {
          total.push({ locus_group: id })
        }

        if (selected === STATUS_IN_PROGRESS) {
          const children = childData.reduce((result, childItem) => {
            if (childItem.selected === STATUS_COMPLETED) {
              const childType = childItem.type ?? 'locus'
              result.push({
                [type]: childItem.parentId,
                [childType]: childItem.id,
              })
            }

            return result
          }, [])

          total.push(...children)
        }
      } else if (selected === STATUS_COMPLETED) {
        total.push({ [type]: id })
      }

      return total
    }, [])
  }

  makeSelected = value => {
    const { data } = this.state

    return data.map(item => {
      /* eslint-disable no-param-reassign */
      item.selected = value

      if (item.childData.length > 0) {
        item.childData.forEach(child => {
          child.selected = value
        })
      }

      return item
    })
  }

  getSelectedIcon = value => {
    switch (value) {
      case STATUS_COMPLETED: {
        return <Checked className="ic-selection" />
      }

      case STATUS_IN_PROGRESS: {
        return <InProgress className="ic-selection" />
      }

      case STATUS_NOT_STARTED: {
        return <Unchecked className="ic-selection" />
      }

      default:
        return null
    }
  }

  // eslint-disable-next-line max-statements
  handleItemClick = value => {
    if (!value) {
      return this.handleAllSelectedClick()
    }

    const { data } = this.state
    const parentItem =
      value.parentId && data.find(item => item.id === value.parentId)
    const modifyChildrenStatus = (children, status) =>
      children.map(child => {
        child.selected = status

        return child
      })

    if (value.selected === STATUS_NOT_STARTED) {
      if (parentItem) {
        if (parentItem.selected === STATUS_NOT_STARTED) {
          parentItem.selected = STATUS_IN_PROGRESS
        }

        parentItem.childData[value.index].selected = STATUS_COMPLETED
        data[parentItem.index] = parentItem
      } else {
        if (value.childData && value.childData.length > 0) {
          value.childData = modifyChildrenStatus(
            value.childData,
            STATUS_COMPLETED,
          )
        }

        value.selected = STATUS_COMPLETED
        data[value.index] = value
      }
    } else if (value.selected === STATUS_IN_PROGRESS) {
      if (value.childData && value.childData.length > 0) {
        value.childData = modifyChildrenStatus(
          value.childData,
          STATUS_COMPLETED,
        )
      }

      value.selected = STATUS_COMPLETED
      data[value.index] = value
    } else if (parentItem) {
      parentItem.childData[value.index].selected = STATUS_NOT_STARTED
      data[parentItem.index] = parentItem
    } else {
      if (value.childData && value.childData.length > 0) {
        value.childData = modifyChildrenStatus(
          value.childData,
          STATUS_NOT_STARTED,
        )
      }

      value.selected = STATUS_NOT_STARTED
      /* eslint-enable no-param-reassign */
      data[value.index] = value
    }

    if (parentItem) {
      parentItem.selected = this.getParentStatus(parentItem.childData)
    }

    this.getAllSelectedState()
    this.setState({ ...data })
  }

  getParentStatus = parent => {
    let status = STATUS_NOT_STARTED
    let completedCould = 0

    for (const key in parent) {
      if (parent.hasOwnProperty(key)) {
        const item = parent[key]
        const children = item.childData

        if (item.selected !== STATUS_NOT_STARTED) {
          status = STATUS_IN_PROGRESS
          completedCould += 1
        }

        if (children && children.length) {
          for (const childKey in children) {
            if (children.hasOwnProperty(childKey)) {
              const elem = children[childKey]

              if (elem.selected !== STATUS_NOT_STARTED) {
                status = STATUS_IN_PROGRESS
              }
            }
          }
        }
      }
    }

    if (
      parent.length === completedCould &&
      parent.every(item => item.selected === STATUS_COMPLETED)
    ) {
      status = STATUS_COMPLETED
    }

    return status
  }

  renderListItem = unit => {
    const childRender =
      unit.childData &&
      unit.childData.map(child => this.renderItem(child, 'second'))

    return [this.renderItem(unit, 'first'), childRender]
  }

  renderItem = (unit, level) => (
    <MenuItem
      key={unit.key}
      value={unit.id}
      onClick={evt => this.handleItemClick(unit, evt)}
      className={`list-item ${level}-level`}
      item={unit}>
      {this.getSelectedIcon(unit.selected)}
      <span className="item-name">{unit.name}</span>
    </MenuItem>
  )

  renderChildren = () => {
    const { allSelected, data } = this.state

    return [
      <MenuItem
        key="all-selected"
        className="list-item all-selected"
        value={ALL_SELECTED}
        onClick={this.handleAllSelectedClick}>
        {this.getSelectedIcon(allSelected)}
        <span className="item-name">{formatMessage('all_selected')}</span>
      </MenuItem>,
      data.map(item => this.renderListItem(item)),
    ]
  }

  getSelectValue = () => {
    const { data, allSelected } = this.state

    if (allSelected === STATUS_COMPLETED) {
      return formatMessage('all_selected')
    }

    return data
      .reduce((total, item) => {
        const hasChildren = item.childData

        if (item.selected === STATUS_COMPLETED) {
          total.push(item.name)
        }
        if (hasChildren && hasChildren.length) {
          hasChildren.forEach(child => {
            if (child.selected === STATUS_COMPLETED) {
              total.push(child.name)
            }
          })
        }

        return total
      }, [])
      .join(', ')
  }

  handleCloseSelect = () => {
    const { setData } = this.props
    const selectedValue = this.handleExportData()

    setData(selectedValue)
  }

  render() {
    const { data } = this.state
    const { className, selectView, inputLabel } = this.props
    const value = this.getSelectValue() ? this.getSelectValue().split(', ') : []

    if (selectView) {
      return (
        <FormControl fullWidth>
          <InputLabel>{inputLabel}</InputLabel>
          <Select
            multiple
            value={value}
            renderValue={this.getSelectValue}
            disabled={!data.length}
            onClose={this.handleCloseSelect}
            MenuProps={{
              className: 'unit-select-list all-selected-mode',
              getContentAnchorEl: null,
            }}>
            {this.renderChildren()}
          </Select>
        </FormControl>
      )
    }

    return <div className={className}>{this.renderChildren()}</div>
  }
}

export default NestedList
